// ───────────────────────────────────────────────
// Route guard. Renders its children only for an authenticated user;
// otherwise redirects to /login, preserving the intended destination so
// the user lands back where they were headed after signing in.
// ───────────────────────────────────────────────
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function RequireAuth({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Hold the route until the first /api/auth/me hydration settles — without
  // this, an authenticated user is bounced to /login on every page reload.
  if (loading) {
    return (
      <div className="auth-shell">
        <div className="auth-loading">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
